import { render, staticRenderFns } from "./SimProject.vue?vue&type=template&id=5e3223b0&scoped=true"
import script from "./SimProject.vue?vue&type=script&lang=js"
export * from "./SimProject.vue?vue&type=script&lang=js"
import style0 from "./SimProject.vue?vue&type=style&index=0&id=5e3223b0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3223b0",
  null
  
)

export default component.exports